export const ambiente = "prod";
export const prodIp = "https://kamanda.app.br:7200";
export const devIp = "http://localhost:7200";


